import React, { ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ContractForm from 'pricing/components/contract/contractForm/ContractForm';
import ContractNotFound from 'pricing/components/contract/contractNotFound/ContractNotFound';
import { PricingLayoutPageHeaderStyled } from 'pricing/components/layout/PricingLayout.styles';
import LoadingPage from 'pricing/components/loadingPage/LoadingPage';
import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import { fetchContract } from 'pricing/utilities/contract/fetchContract/fetchContract';
import { testId } from 'pricing/utilities/test/dataTestId';
import { PricingRouteContractEditParams, PricingRoutes } from 'pricing/types';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { BreadcrumbItem } from 'types';

const breadcrumbs: BreadcrumbItem[] = [
  {
    key: 'main',
    label: 'Main',
    path: '/',
  },
  {
    key: 'pricing',
    label: 'Pricing',
  },
  {
    key: 'contractCreate',
    label: 'Contracts',
    path: PricingRoutes.ContractList,
  },
  {
    key: 'contract',
    label: 'Contract',
  },
];

function ContractViewContent(): ReactElement {
  const { contractId }: PricingRouteContractEditParams = useParams();
  const { dispatch: dispatchLayout } = useLayoutState();
  const { state, dispatch } = useContractState();
  const { loading } = state;
  const [contractNotFound, setContractNotFound] = useState(false);

  useEffect(() => {
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs });
    dispatch({ type: 'SET_CONTRACT_MODE', contractMode: 'view' });
    dispatch({ type: 'LOADING_CONTRACT' });
    fetchContract(Number(contractId)).then((contract) => {
      dispatch({ type: 'SET_CONTRACT', contract });
      setContractNotFound(!contract);
    });
  }, []);

  return (
    <main data-testid={testId.pricingPageContractView}>
      <section data-testid={testId.pricingLayoutPageHeader}>
        <PricingLayoutPageHeaderStyled title="Contract" />
      </section>
      {loading ? (
        <LoadingPage />
      ) : contractNotFound ? (
        <ContractNotFound />
      ) : (
        <ContractForm />
      )}
    </main>
  );
}

export default ContractViewContent;
